import { render, staticRenderFns } from "./NicknameDropdown.vue?vue&type=template&id=c489d722&scoped=true"
import script from "./NicknameDropdown.js?vue&type=script&lang=js&external"
export * from "./NicknameDropdown.js?vue&type=script&lang=js&external"
import style0 from "./NicknameDropdown.vue?vue&type=style&index=0&id=c489d722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c489d722",
  null
  
)

export default component.exports